import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoMaskedTextBoxMixin from './KendoMaskedTextBoxMixin'

export default {
    name: 'kendo-maskedtextbox',
    mixins: [ KendoMaskedTextBoxMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        if(this.v3) {
            return h('input',{
                value: this.value
            })
        } else {
            return h('input',{
                props: {
                    value: this.value
                }
            })
        }
       
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoMaskedTextBox/index.js